module.exports = __webpack_public_path__ + "static/media/guide-cover.6cf313ee.svg";